export const errorTexts = {
  invalidEmail: "Invalid email address",
  password:
    "Password must contain at least 10 characters, 1 upper case and 1 number.",
  userNotFound: "Invalid email and/or password",
  onlyNumbers: "Only numbers are allowed",
  recordId: "Must start with “rec” and contain 17 characters",
};
